export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6367.d3c795ee.jpg";